export default __webpack_public_path__ + "static/media/idealLogo.5a85b3b6.webp";